<template>
  <component
    v-if="modal.component"
    :is="modal.component"
    :is-loading="loading"
    v-bind="modal.props"
    v-on="modal.listeners"
    ref="modal"
  />
</template>

<script>
import ActionToRequirePasswordModal from '@/domain/components/generalPanel/adminPanel/user/modal/ActionToRequirePasswordModal';
import PasswordResetEmailSentModal from '@/domain/components/generalPanel/adminPanel/user/modal/PasswordResetEmailSentModal';
import PasswordResetModal from '@/domain/components/generalPanel/adminPanel/user/modal/PasswordResetModal';

export default {
  components: {
    ActionToRequirePasswordModal,
    PasswordResetEmailSentModal,
    PasswordResetModal,
  },
  data: () => ({
    password: null,
    eMail: null,
    showModal: false,
    loading: false,
    modal: {
      component: null,
      props: {},
      listeners: {},
    },
  }),
  methods: {
    show(password, eMail) {
      this.eMail = eMail;
      this.password = password;

      this.modal = {
        component: PasswordResetModal,
        listeners: {
          ok: this.close,
          'send-email': this.onSendEmail,
        },
      };

      this.$nextTick(() => {
        this.$refs.modal.show(password, eMail);
        this.showModal = true;
      });
    },
    showPasswordConfirmationModal(user) {
      this.loading = true;
      this.modal = {
        component: ActionToRequirePasswordModal,
        props: {
          title: 'user-manager.generate-new-password-modal.title',
          message: 'user-manager.generate-new-password-modal.message',
        },
        listeners: {
          ok: this.stopLoading,
          submit: event => this.propagateEvent(event, 'send-email-submit'),
        },
      };

      this.$nextTick(() => {
        this.$refs.modal.show(user);
        this.showModal = true;
      });
    },
    showEmailSent(eMail) {
      this.loading = false;
      this.eMail = eMail;

      this.modal = {
        component: PasswordResetEmailSentModal,
        listeners: {
          ok: this.close,
          cancel: this.stopLoading,
        },
      };

      this.$nextTick(() => {
        this.$refs.modal.show(eMail);
        this.showModal = true;
      });
    },
    propagateEvent(event, eventName) {
      if (eventName) {
        this.$emit(eventName, event);
        return;
      }
      this.$emit(event.type, event.value);
      this.close();
    },
    close() {
      if (this.showModal) {
        this.$emit('ok');
        this.showModal = false;
        this.$refs.modal.closeModal();
      }
    },
    stopLoading() {
      if (this.loading) {
        this.loading = false;
        this.show(this.password, this.eMail);
      }
    },
    onSendEmail() {
      this.loading = true;
      this.$emit('send-email');
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
